module.exports = __webpack_public_path__ + "hero-trailer-image.jpg";